export class Campo {
  id: string;
  idGrupo: string;
  idTipoCampo: string;
  ordem: string;
  obrigatorio: string;
  descricao: string;
  value: string;
}